export function isTrue(val) {
  return val === true || val === 'true';
}